import { useTheme } from "../../context/ThemeContext";
import { useTranslation } from "react-i18next";

export default function CyberBrand({ size = "md", showSubtitle = true }) {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const brandLogo =
    theme === "dark"
      ? "/brand/quantum-logo-dark.png"
      : "/brand/quantum-logo.png";

  // Determine size classes
  let containerGapClass = "gap-3.5";
  let logoSizeClass = "h-11 w-11";
  let radarSizeClass = "h-16 w-16";
  let titleSizeClass = "text-lg font-bold tracking-wide";
  let subtitleSizeClass = "text-[11px]";

  if (size === "sm") {
    containerGapClass = "gap-2.5";
    logoSizeClass = "h-8 w-8";
    radarSizeClass = "h-12 w-12";
    titleSizeClass = "text-base font-bold tracking-tight";
    subtitleSizeClass = "text-[9.5px]";
  } else if (size === "lg") {
    containerGapClass = "gap-4.5";
    logoSizeClass = "h-14 w-14";
    radarSizeClass = "h-20 w-20";
    titleSizeClass = "text-xl font-bold tracking-wider";
    subtitleSizeClass = "text-xs";
  }

  return (
    <div className={`flex items-center ${containerGapClass} select-none cyber-brand-wrapper group`}>
      {/* Radar Screen Container */}
      <div className={`relative ${radarSizeClass} flex items-center justify-center shrink-0 radar-container rounded-full overflow-hidden`}>
        {/* Radar Crosshairs */}
        <div className="absolute inset-0 radar-crosshair-h" />
        <div className="absolute inset-0 radar-crosshair-v" />
        
        {/* Concentric Radar Rings */}
        <div className="absolute inset-1.5 border border-(--color-primary) rounded-full opacity-15" />
        <div className="absolute inset-4.5 border border-(--color-primary) rounded-full opacity-10" />

        {/* Rotating Radar Sweep Cone */}
        <div className="absolute inset-0 radar-sweep" />

        {/* Active Node Blips (Hosts in Cyber Range) */}
        <span className="radar-blip blip-1" />
        <span className="radar-blip blip-2" />
        <span className="radar-blip blip-3" />

        {/* Center Logo Icon */}
        <img
          src={brandLogo}
          alt={t("navbar.brand")}
          className={`${logoSizeClass} object-contain z-10 transition-all duration-300 group-hover:scale-105 group-hover:filter group-hover:drop-shadow-[0_0_8px_var(--color-primary)]`}
        />
      </div>

      {/* Brand Title & Tagline details */}
      <div className="leading-tight text-left">
        <div className={`${titleSizeClass} text-(--color-primary) tracking-wide flex items-center`}>
          <span className="cyber-brand-text">{t("navbar.brand")}</span>
          <span className="w-1.5 h-3.5 bg-(--color-primary) inline-block ml-1 animate-terminal-blink opacity-75" />
        </div>

        {showSubtitle && (
          <div className="font-mono text-(--color-text-muted) tracking-wide mt-0.5 flex items-center gap-1.5">
            <span className="relative flex h-1.5 w-1.5 shrink-0">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500"></span>
            </span>
            <span className={`${subtitleSizeClass}`}>
              {t("auth.shell.enterprise_tagline")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
